import { render, staticRenderFns } from "./ComparatorLayout.vue?vue&type=template&id=bcc9bcda"
import script from "./ComparatorLayout.vue?vue&type=script&lang=ts"
export * from "./ComparatorLayout.vue?vue&type=script&lang=ts"
import style0 from "./ComparatorLayout.vue?vue&type=style&index=0&id=bcc9bcda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@4.3.0_lodash@4.17.21_prettier@2.8.8_react-dom@18.3.1_react@17.0_5ioacul63gvtxmolb2qhpey7py/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports